import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <g transform="translate(9.000000, 15.000000)">
          <path
            d="M 42.2258 15.2 L 33 35 L 33 45 L 27 45 L 27 35 L 17.7343 15.2 L 25.0582 15.2 L 29 27 C 29 27 29.355 27.959 30 29 L 30 29 C 30.667 27.925 31 27 31 27 L 35.4718 15.2 L 42.2258 15.2 Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
